import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 198,0 L 52,348 C 52 390 245,400 245,392" fill={colors.light} />
      <path d="M 245,392 C 245,395 345,380 345,348 L 198,0" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
